import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SEO, { createWebPageSchema, createBreadcrumbSchema, createOrganizationSchema } from '../../components/feature/SEO';

const TermsOfService = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://unqcode.com';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sections = isRTL ? [
    {
      icon: 'ri-file-text-line',
      title: 'قبول الشروط',
      content: [
        'باستخدام موقع يونيك كود (unqcode.com) أو أي من خدماتنا، فإنك تقرّ بأنك قرأت وفهمت وتوافق على الالتزام بهذه الشروط وجميع القوانين واللوائح المعمول بها.',
        'إذا كنت تمثل شركة أو مؤسسة، فأنت تضمن أن لديك الصلاحية لقبول هذه الشروط نيابةً عنها.',
        'إذا كنت لا توافق على هذه الشروط أو أي جزء منها، يرجى التوقف عن استخدام خدماتنا.',
        'نحتفظ بالحق في تعديل هذه الشروط في أي وقت. الاستمرار في استخدام الخدمات بعد التعديلات يُعدّ قبولاً للشروط المحدثة.',
      ],
    },
    {
      icon: 'ri-service-line',
      title: 'وصف الخدمات',
      content: [
        'تُقدّم يونيك كود مجموعة من الخدمات التقنية تشمل: تصميم الهوية البصرية والعلامة التجارية، تطوير مواقع الويب، تطوير تطبيقات الجوال، حلول الذكاء الاصطناعي، التسويق الرقمي، والاستشارات التقنية.',
        'تخضع جميع الخدمات لعقد خدمات منفصل يُبيّن النطاق والتسليمات والجداول الزمنية والشروط المالية.',
        'نحتفظ بالحق في تعديل الخدمات أو وقفها أو إيقافها بإشعار مسبق معقول.',
      ],
    },
    {
      icon: 'ri-copyright-line',
      title: 'الملكية الفكرية',
      content: [
        'جميع محتويات الموقع من نصوص وصور وشعارات ورسومات وكود برمجي هي ملكية حصرية ليونيك كود وتحميها قوانين حقوق الملكية الفكرية.',
        'لا يحق لك نسخ أو توزيع أو تعديل أي محتوى من الموقع دون إذن كتابي صريح منا.',
        'بعد الدفع الكامل للمشروع، تنتقل ملكية المنتجات النهائية التي أُنجزت خصيصاً لك إليك وفقاً لما هو محدد في عقد الخدمة.',
        'الأدوات والأطر والمكونات التي طوّرناها مسبقاً تبقى ملكيةً لنا، ونمنحك ترخيصاً باستخدامها في المشروع الخاص بك.',
      ],
    },
    {
      icon: 'ri-bank-card-line',
      title: 'الدفع والفوترة',
      content: [
        'تخضع شروط الدفع للعقد المبرم مع كل عميل، وتشمل عادةً دفعة مقدمة عند بدء المشروع.',
        'جميع الأسعار بالدولار الأمريكي ما لم يُتفق على غير ذلك. وقد تُطبَّق ضرائب إضافية وفقاً لموقعك الجغرافي.',
        'التأخر في السداد قد يترتب عليه تأخر في تسليم المشروع أو وقف الخدمات مؤقتاً.',
        'في نموذج تقاسم الأرباح، يتم الاتفاق على نسب الأرباح وآليات الدفع صراحةً في اتفاقية الشراكة.',
      ],
    },
    {
      icon: 'ri-lock-line',
      title: 'السرية',
      content: [
        'نلتزم بالحفاظ على سرية جميع المعلومات التجارية الحساسة التي تشاركها معنا خلال مدة التعاون وبعدها.',
        'يُتوقع منك أيضاً الحفاظ على سرية أي أدوات أو عمليات أو معلومات داخلية تطلع عليها من خلال تعاملك معنا.',
        'استثناءات السرية تشمل: المعلومات المتاحة للعموم، المعلومات المطلوبة بموجب القانون، والمعلومات التي أُجيز إفصاحها كتابياً.',
      ],
    },
    {
      icon: 'ri-error-warning-line',
      title: 'حدود المسؤولية',
      content: [
        'لن تكون يونيك كود مسؤولة عن أي أضرار غير مباشرة أو عرضية أو خاصة أو تبعية ناجمة عن استخدام أو عدم القدرة على استخدام خدماتنا.',
        'المسؤولية القصوى الإجمالية لنا لا تتجاوز المبلغ الإجمالي المدفوع لنا خلال الثلاثة أشهر الأخيرة السابقة للحادثة.',
        'لا نضمن أن خدماتنا ستكون متاحة دون انقطاع أو خالية من الأخطاء في جميع الأوقات.',
        'نحن غير مسؤولين عن المحتوى الذي تقدمه لنا أو عن أي انتهاك لحقوق الطرف الثالث ناجم عن المواد التي تزودنا بها.',
      ],
    },
    {
      icon: 'ri-scales-line',
      title: 'تسوية النزاعات',
      content: [
        'تخضع هذه الشروط وتُفسَّر وفقاً لقوانين المملكة العربية السعودية.',
        'في حال نشوء أي نزاع، يسعى الطرفان أولاً إلى حله وديّاً خلال 30 يوماً من تاريخ الإشعار.',
        'إذا تعذّر الحل الودي، يُحال النزاع إلى التحكيم وفقاً لقواعد المركز السعودي للتحكيم التجاري.',
        'تُجرى جلسات التحكيم في الرياض باللغة العربية، وتكون قراراته نهائية وملزمة للطرفين.',
      ],
    },
    {
      icon: 'ri-shield-user-line',
      title: 'استخدام مقبول',
      content: [
        'يحظر استخدام خدماتنا لأي أغراض غير قانونية أو محظورة بموجب هذه الشروط.',
        'يُمنع استخدام خدماتنا لنشر محتوى مسيء أو مُضلّل أو ينتهك حقوق الآخرين.',
        'يُحظر محاولة الوصول غير المصرح به لأنظمتنا أو انتهاك أمن شبكتنا.',
        'نحتفظ بالحق في إنهاء الخدمة فوراً في حال انتهاك هذه الشروط دون إشعار مسبق وتعويض.',
      ],
    },
  ] : [
    {
      icon: 'ri-file-text-line',
      title: 'Acceptance of Terms',
      content: [
        'By using the Unique Code website (unqcode.com) or any of our services, you acknowledge that you have read, understood, and agree to be bound by these Terms and all applicable laws and regulations.',
        'If you represent a company or organization, you warrant that you have the authority to accept these Terms on its behalf.',
        'If you do not agree to these Terms or any part of them, please stop using our services.',
        'We reserve the right to modify these Terms at any time. Continued use of the services after modifications constitutes acceptance of the updated Terms.',
      ],
    },
    {
      icon: 'ri-service-line',
      title: 'Description of Services',
      content: [
        'Unique Code provides a range of technology services including: visual identity and branding design, website development, mobile application development, AI solutions, digital marketing, and IT consulting.',
        'All services are subject to a separate service agreement that details scope, deliverables, timelines, and financial terms.',
        'We reserve the right to modify, suspend, or discontinue services with reasonable prior notice.',
      ],
    },
    {
      icon: 'ri-copyright-line',
      title: 'Intellectual Property',
      content: [
        'All website content including texts, images, logos, graphics, and code is the exclusive property of Unique Code and is protected by intellectual property laws.',
        'You may not copy, distribute, or modify any website content without our explicit written permission.',
        'Upon full payment for the project, ownership of final deliverables created specifically for you transfers to you as specified in the service agreement.',
        'Tools, frameworks, and components we developed previously remain our property, and we grant you a license to use them in your specific project.',
      ],
    },
    {
      icon: 'ri-bank-card-line',
      title: 'Payment & Billing',
      content: [
        'Payment terms are governed by the agreement entered into with each client, and typically include an upfront payment at project initiation.',
        'All prices are in USD unless otherwise agreed. Additional taxes may apply depending on your geographic location.',
        'Delayed payment may result in delayed project delivery or temporary suspension of services.',
        "In the revenue-sharing model, profit shares and payment mechanisms are explicitly agreed upon in the partnership agreement.",
      ],
    },
    {
      icon: 'ri-lock-line',
      title: 'Confidentiality',
      content: [
        'We commit to maintaining the confidentiality of all sensitive business information you share with us during and after the collaboration period.',
        'You are also expected to maintain the confidentiality of any tools, processes, or internal information you become aware of through your dealings with us.',
        'Exceptions to confidentiality include: publicly available information, information required by law, and information whose disclosure has been authorized in writing.',
      ],
    },
    {
      icon: 'ri-error-warning-line',
      title: 'Limitation of Liability',
      content: [
        'Unique Code will not be liable for any indirect, incidental, special, or consequential damages arising from the use of or inability to use our services.',
        'Our maximum aggregate liability does not exceed the total amount paid to us during the three months preceding the incident.',
        'We do not guarantee that our services will be available without interruption or error-free at all times.',
        'We are not responsible for content you provide to us or for any infringement of third-party rights resulting from materials you supply to us.',
      ],
    },
    {
      icon: 'ri-scales-line',
      title: 'Dispute Resolution',
      content: [
        'These Terms are governed by and interpreted in accordance with the laws of the Kingdom of Saudi Arabia.',
        'In the event of any dispute, both parties shall first seek to resolve it amicably within 30 days from the date of notice.',
        'If amicable resolution fails, the dispute shall be referred to arbitration in accordance with the rules of the Saudi Center for Commercial Arbitration.',
        'Arbitration sessions shall be conducted in Riyadh in Arabic, and its decisions shall be final and binding on both parties.',
      ],
    },
    {
      icon: 'ri-shield-user-line',
      title: 'Acceptable Use',
      content: [
        'You are prohibited from using our services for any illegal purposes or purposes prohibited under these Terms.',
        "You may not use our services to publish offensive, misleading, or rights-infringing content.",
        'Attempting unauthorized access to our systems or violating our network security is strictly prohibited.',
        'We reserve the right to immediately terminate service in case of violation of these Terms without prior notice or compensation.',
      ],
    },
  ];

  return (
    <div className={`min-h-screen bg-white ${isRTL ? 'font-arabic' : ''}`} dir={isRTL ? 'rtl' : 'ltr'}>
      <SEO
        title={t('seo.termsTitle')}
        description={t('seo.termsDesc')}
        keywords="terms of service, terms and conditions, legal terms, شروط الاستخدام, الشروط والأحكام"
        canonical={`${siteUrl}/terms`}
        ogType="website"
        schema={{
          '@context': 'https://schema.org',
          '@graph': [
            createWebPageSchema(
              isRTL ? 'شروط الاستخدام | الكود المميز - Unique Code' : 'Terms of Service | Unique Code - الكود المميز',
              isRTL 
                ? 'شروط استخدام موقع وخدمات الكود المميز. يرجى قراءة هذه الشروط بعناية قبل استخدام خدماتنا.' 
                : 'Terms of Use for Unique Code website and services. Please read these terms carefully before using our services.',
              '/terms'
            ),
            createOrganizationSchema(),
            createBreadcrumbSchema([
              { name: 'Home', url: '/' },
              { name: isRTL ? 'شروط الاستخدام' : 'Terms of Service', url: '/terms' },
            ]),
            {
              '@type': 'TermsOfService',
              '@id': `${siteUrl}/terms#termsofservice`,
              name: isRTL ? 'شروط الاستخدام - الكود المميز' : 'Terms of Service - Unique Code',
              description: isRTL
                ? 'شروط استخدام موقع وخدمات الكود المميز. يرجى قراءة هذه الشروط بعناية قبل استخدام خدماتنا.'
                : 'Terms of Use for Unique Code website and services. Please read these terms carefully before using our services.',
              url: `${siteUrl}/terms`,
              datePublished: '2025-03-01',
              dateModified: '2025-03-01',
              inLanguage: ['en', 'ar'],
              publisher: {
                '@id': `${siteUrl}/#organization`,
              },
              isPartOf: {
                '@id': `${siteUrl}/#website`,
              },
            },
          ],
        }}
      />
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-16 bg-gray-950 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/89063b05892e95187cc31eaa8b566329.jpg"
            alt="background"
            className="w-full h-full object-cover object-top opacity-20"
            loading="lazy"
            decoding="async"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-gray-950/80 to-gray-950"></div>
        </div>
        <div className="relative max-w-4xl mx-auto px-6 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-red/20 border border-brand-red/30 rounded-full text-brand-red text-sm font-semibold mb-6">
            <i className="ri-scales-line text-sm"></i>
            {isRTL ? 'الشروط القانونية' : 'Legal Terms'}
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight">
            {isRTL ? 'شروط الاستخدام' : 'Terms of Service'}
          </h1>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            {isRTL
              ? 'يرجى قراءة هذه الشروط بعناية قبل استخدام خدمات يونيك كود. استخدامك لخدماتنا يُعدّ موافقةً على هذه الشروط.'
              : 'Please read these Terms carefully before using Unique Code services. Your use of our services constitutes acceptance of these Terms.'}
          </p>
          <p className="text-gray-500 text-sm mt-4">
            {isRTL ? 'آخر تحديث: مارس 2025' : 'Last updated: March 2025'}
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6">
          {/* Intro */}
          <div className="bg-amber-50 rounded-2xl p-8 mb-10 border border-amber-100">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-xl flex-shrink-0">
                <i className="ri-alert-line text-amber-600 text-xl"></i>
              </div>
              <div>
                <h2 className="font-bold text-gray-900 text-lg mb-2">
                  {isRTL ? 'تنبيه مهم' : 'Important Notice'}
                </h2>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {isRTL
                    ? 'تُشكّل هذه الشروط اتفاقية قانونية ملزمة بينك وبين يونيك كود. إن كنت لا توافق على أي بند من هذه الشروط، رجاءً لا تستخدم خدماتنا. للاستفسار عن أي بند، تواصل معنا قبل استخدام الخدمات.'
                    : 'These Terms constitute a legally binding agreement between you and Unique Code. If you do not agree to any clause in these Terms, please do not use our services. For inquiries about any clause, contact us before using our services.'}
                </p>
              </div>
            </div>
          </div>

          {/* Table of Contents */}
          <div className="bg-white rounded-2xl border border-gray-100 p-6 mb-10">
            <h3 className="font-bold text-gray-900 mb-4 text-sm uppercase tracking-wide">
              {isRTL ? 'المحتويات' : 'Table of Contents'}
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              {sections.map((section, idx) => (
                <a
                  key={idx}
                  href={`#term-${idx}`}
                  className="flex items-center gap-2 text-sm text-gray-600 hover:text-brand-red transition-colors cursor-pointer py-1"
                >
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className={`${section.icon} text-brand-red text-sm`}></i>
                  </div>
                  {section.title}
                </a>
              ))}
            </div>
          </div>

          {/* Sections */}
          <div className="space-y-10">
            {sections.map((section, idx) => (
              <div key={idx} id={`term-${idx}`} className="scroll-mt-24 rounded-2xl border border-gray-100 p-8 hover:border-brand-red/20 transition-colors">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 flex items-center justify-center bg-brand-red/10 rounded-xl flex-shrink-0">
                    <i className={`${section.icon} text-brand-red text-lg`}></i>
                  </div>
                  <div>
                    <span className="text-brand-red text-xs font-semibold">
                      {isRTL ? `المادة ${idx + 1}` : `Article ${idx + 1}`}
                    </span>
                    <h2 className="text-lg font-bold text-gray-900">{section.title}</h2>
                  </div>
                </div>
                <div className="space-y-3 pr-2">
                  {section.content.map((item, iIdx) => (
                    <div key={iIdx} className="flex items-start gap-3">
                      <div className="w-6 h-6 flex items-center justify-center bg-gray-100 rounded-full flex-shrink-0 mt-0.5">
                        <span className="text-gray-500 text-xs font-semibold">{iIdx + 1}</span>
                      </div>
                      <p className="text-gray-600 text-sm leading-relaxed">{item}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Links to other legal pages */}
          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Link
              to="/privacy"
              className="flex items-center gap-4 p-6 bg-gray-50 rounded-2xl border border-gray-100 hover:border-brand-red/30 transition-all cursor-pointer group"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-brand-red/10 rounded-xl group-hover:bg-brand-red/20 transition-colors flex-shrink-0">
                <i className="ri-shield-check-line text-brand-red text-lg"></i>
              </div>
              <div>
                <p className="font-semibold text-gray-900 text-sm">
                  {isRTL ? 'سياسة الخصوصية' : 'Privacy Policy'}
                </p>
                <p className="text-gray-500 text-xs mt-0.5">
                  {isRTL ? 'كيف نحمي بياناتك' : 'How we protect your data'}
                </p>
              </div>
              <i className={isRTL ? 'ri-arrow-left-s-line text-gray-400 group-hover:text-brand-red transition-colors mr-auto' : 'ri-arrow-right-s-line text-gray-400 group-hover:text-brand-red transition-colors mr-auto'}></i>
            </Link>
            <Link
              to="/contact"
              className="flex items-center gap-4 p-6 bg-gray-50 rounded-2xl border border-gray-100 hover:border-brand-red/30 transition-all cursor-pointer group"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-brand-red/10 rounded-xl group-hover:bg-brand-red/20 transition-colors flex-shrink-0">
                <i className="ri-customer-service-line text-brand-red text-lg"></i>
              </div>
              <div>
                <p className="font-semibold text-gray-900 text-sm">
                  {isRTL ? 'تواصل معنا' : 'Contact Us'}
                </p>
                <p className="text-gray-500 text-xs mt-0.5">
                  {isRTL ? 'لأي استفسار قانوني' : 'For any legal inquiries'}
                </p>
              </div>
              <i className={isRTL ? 'ri-arrow-left-s-line text-gray-400 group-hover:text-brand-red transition-colors mr-auto' : 'ri-arrow-right-s-line text-gray-400 group-hover:text-brand-red transition-colors mr-auto'}></i>
            </Link>
          </div>

          {/* Contact box */}
          <div className="mt-8 bg-gray-950 rounded-2xl p-8 text-center">
            <h3 className="text-white font-bold text-xl mb-2">
              {isRTL ? 'هل تحتاج توضيحاً قانونياً؟' : 'Need Legal Clarification?'}
            </h3>
            <p className="text-gray-400 text-sm mb-6">
              {isRTL
                ? 'فريقنا القانوني جاهز للإجابة على استفساراتك حول هذه الشروط.'
                : 'Our legal team is ready to answer your questions about these Terms.'}
            </p>
            <a
              href="mailto:Info@unqcode.com"
              className="inline-flex items-center gap-2 px-6 py-3 bg-brand-red text-white rounded-xl text-sm font-semibold hover:bg-brand-red-dark transition-all cursor-pointer"
            >
              <i className="ri-mail-send-line"></i>
              Info@unqcode.com
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermsOfService;
